import PathConstants from "@routes/PathConstantsMain";
import React, { useState } from 'react';
import { Link, useMatch } from 'react-router'
import {
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Row
} from "reactstrap";

//import Components
import LanguageDropdown from "./LanguageDropdown";

//i18n
import { withTranslation } from "react-i18next";

//images
import brjLogo from '@assets/images/transparent.png'

function Header({ t }) {
  const [collapsed, setCollapsed] = useState(true);
  const toggleNavbar = () => setCollapsed(!collapsed);

  return (
	<header>
		<Container>
			<div className="row menu">
				<Navbar expand="xl" fixed="top" className="rounded justify-content-center text-center">
					<NavbarToggler onClick={toggleNavbar} aria-controls="brj-navbar" aria-label={t("Navigation umschalten")} />
					<Collapse isOpen={!collapsed} id="brj-navbar" className="d-xl-flex" navbar>
					  <NavbarBrand href="https://www.brj-berlin.de/" target="_blank" className="col-xxl-3 col-xl-3 col-lg-12 navbar-brand mb-xl-4 me-xl-0"><img src={brjLogo} alt={t("BRJ-Logo")} /></NavbarBrand>
					  <Nav className="col-xxl-6 col-xl-6 col-lg-12 justify-content-xl-center navbar-nav">
						<NavItem>
							<NavLink to={PathConstants.START} tag={Link} active={Boolean(useMatch(PathConstants.START))}>{t("Start")}</NavLink>
						</NavItem>
						<NavItem>
							<NavLink to={PathConstants.BESCHWERDE} tag={Link} active={Boolean(useMatch(PathConstants.BESCHWERDE))}>{t("Beschwerde")}</NavLink>
						</NavItem>
						<NavItem>
							<NavLink to={PathConstants.ABLAUF} tag={Link} active={Boolean(useMatch(PathConstants.ABLAUF))}>{t("Ablauf")}</NavLink>
						</NavItem>
						<NavItem>
							<NavLink to={PathConstants.ANGEBOT} tag={Link} active={Boolean(useMatch(PathConstants.ANGEBOT))}>{t("Angebot")}</NavLink>
						</NavItem>

						{/* LanguageDropdown */}
						<LanguageDropdown />
					  </Nav>
					  <Nav className="d-xl-flex col-xxl-3 col-xl-3 justify-content-xl-end">
						<NavLink className="btn br-light p-2" cssModule={{ 'nav-link': 'btn-outline-primary' }} id="BearbeitungsstandMenuLink" to={PathConstants.BEARBEITUNGSSTAND} tag={Link} active={Boolean(useMatch(PathConstants.BEARBEITUNGSSTAND))}><span className="emoji">🔁</span>&nbsp;{t("Bearbeitungsstand")}</NavLink>
					  </Nav>
					</Collapse>
				</Navbar>
			</div>
		</Container>
	</header>
  );
}

export default withTranslation()(Header);
